/**
 * ============================================================================
 *  File        : frontend/src/api/hourensou.ts
 *  Module      : api
 *  Purpose     : 報連相(hourensou)型別化 API（v1.3-11；spec §10 + §D5）— list / resolve
 *  Author      : EF Engineering
 *  Created     : 2026-06-02
 *  Updated     : 2026-06-02
 *  License     : Proprietary - ECO FAITH Platform v3.0
 * ============================================================================
 *
 *  後端 handler：crates/api-http/src/routes/v13_hourensou.rs，掛在 v1：
 *    GET  /api/v1/cases/:case_id/hourensou   -> list_hourensou（marketplace.hourensou.view）
 *    POST /api/v1/hourensou/:id/resolve      -> resolve_hourensou（marketplace.hourensou.resolve）
 *  issue_type：field=現場類（陳/工藤）/ numeric=數字類（Gordon）/ process=流程類（EF）。
 */

import { API_BASE, requestData, requestEnvelope, type Envelope } from './client'
import type { ApiSchemas } from './client'

/** 報連相 task DTO（= 後端 HourensouTaskDto）。 */
export type HourensouTaskDto = ApiSchemas['HourensouTaskDto']
/** resolve 的 request body（= 後端 ResolveHourensouDto）。 */
export type ResolveHourensouDto = ApiSchemas['ResolveHourensouDto']

const CASES_PATH = `${API_BASE}/cases`
const HOURENSOU_PATH = `${API_BASE}/hourensou`

/** 列出某案件的所有報連相 task（最新在前）。 */
export function listHourensou(
  caseId: number | string,
): Promise<Envelope<HourensouTaskDto[]>> {
  return requestEnvelope<HourensouTaskDto[]>(`${CASES_PATH}/${caseId}/hourensou`, {
    method: 'GET',
  })
}

/** 將報連相 task 標記 resolved（回傳更新後的 task）。 */
export function resolveHourensou(
  taskId: number | string,
  body: ResolveHourensouDto,
): Promise<HourensouTaskDto> {
  return requestData<HourensouTaskDto>(`${HOURENSOU_PATH}/${taskId}/resolve`, {
    method: 'POST',
    body,
  })
}

export type { Envelope }
